"use client";

const HowSleepApneaAffectsHealth: React.FC = () => {
  const healthImpacts = [
    {
      title: "Daytime Fatigue and Drowsiness",
      description:
        "One of the most common and noticeable symptoms of sleep apnea is excessive daytime sleepiness. Because your breathing is disrupted during sleep, your body is often deprived of the deep, restorative rest it needs. This leads to feelings of fatigue, lack of energy, and an overwhelming need to nap during the day.",
    },
    {
      title: "Cardiovascular Issues",
      description:
        "Sleep apnea has been closely linked to an increased risk of high blood pressure (hypertension), heart disease, and stroke. The repeated drops in blood oxygen levels that occur during apneas put additional strain on the heart, which can lead to abnormal heart rhythms, heart failure, and even heart attacks.",
    },
    {
      title: "Impaired Cognitive Function",
      description:
        "The lack of restorative sleep can affect your brain’s ability to function properly. People with untreated sleep apnea often experience difficulty concentrating, memory problems, mood swings, and even depression. Over time, the constant lack of quality sleep can impair your cognitive abilities, affecting your performance at work, school, and in daily life.",
    },
    {
      title: "Increased Risk of Diabetes",
      description:
        "Sleep apnea is linked to an increased risk of developing type 2 diabetes. This is because the repeated drops in oxygen levels during sleep can disrupt the body’s ability to regulate blood sugar levels effectively. Individuals with sleep apnea may experience insulin resistance, making it harder for their body to manage glucose levels.",
    },
    {
      title: "Weight Gain and Obesity",
      description:
        "There is a strong correlation between sleep apnea and obesity. The fragmented sleep caused by apneas can lead to hormonal imbalances, which increase appetite and cravings for high-calorie foods. Additionally, sleep apnea can reduce your energy levels, making it harder to engage in physical activity and leading to weight gain.",
    },
    {
      title: "Mood Disorders",
      description:
        "Chronic sleep deprivation due to untreated sleep apnea can take a toll on your mental health. Individuals with sleep apnea often report feeling irritable, anxious, and even depressed. The lack of quality sleep affects your emotional regulation, making it harder to manage stress and interact with others in a positive way.",
    },
    {
      title: "Increased Risk of Accidents",
      description:
        "Daytime drowsiness and impaired cognitive function caused by sleep apnea can increase the risk of accidents. People with untreated sleep apnea are more likely to experience car accidents or workplace injuries due to their inability to stay alert and focused.",
    },
  ];

  return (
    <section className="w-full py-10 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
        <h2 className="text-3xl font-semibold text-gray-800 text-center pb-4 after:content-[''] after:block after:w-[250px] after:h-[3px] after:mx-auto after:mt-2 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          How Sleep Apnea Affects Your Health
        </h2>

        <ol className="list-decimal list-inside text-gray-700 text-base sm:text-lg leading-relaxed space-y-4">
          {healthImpacts.map((item, index) => (
            <li key={index}>
              <span className="font-semibold text-black">{item.title}</span>
              <p className="mt-1">{item.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowSleepApneaAffectsHealth;
